import { render, staticRenderFns } from "./PcFields.vue?vue&type=template&id=730df6fe&scoped=true&"
import script from "./PcFields.vue?vue&type=script&lang=js&"
export * from "./PcFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730df6fe",
  null
  
)

export default component.exports